import { Component, Input, OnInit, Inject } from '@angular/core';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';

@Component({
    selector: 'page-error-state',
    templateUrl: './page-error-state.component.html',
    styleUrls: ['./page-error-state.component.scss']
})
export class PageErrorStateComponent implements OnInit {
    @Input() noPermission?: boolean;
    @Input() noPMLicense?: boolean;
    @Input() pageName: string;

    localization: Map<string, string>;

    constructor(
        private cvLocalizationService: CVLocalizationService,
        public configService: CvConfigurationService
    ) { }

    async ngOnInit() {
       await this.cvLocalizationService.GetSection("Gamification_Admin_Messages");
    }

    getLocalizationMessageForLicense(): string {
        let message = this.cvLocalizationService.getCachedText("Gamification_Admin_Messages", "License_Required_Message", "Performance Management license required to access {0} page. Contact the system administrator.");
        message = message.replace('{0}', this.cvLocalizationService.getCachedText("Gamification_Admin_Messages", this.pageName, this.pageName));
        return message;
    }

    getLocalizationMessageForPermissions(): string {
        let message = this.cvLocalizationService.getCachedText("Gamification_Admin_Messages", "Permissions_Required_Message", "To access {0} page, contact the administrator to adjust your permission.");
        message = message.replace('{0}', this.cvLocalizationService.getCachedText("Gamification_Admin_Messages", this.pageName, this.pageName));
        return message;
    }
}
